const getRequiredEnvVar = (name: string) => {
  const value = import.meta.env[name];
  if (!value) {
    console.error(`env var ${name} is not set`);
  }
  return value as string;
};

const getOptionalEnvVar = (name: string) => {
  const value = import.meta.env[name];
  if (!value) {
    return null;
  }
  return value as string;
};

const TOOLS_BASE_URL = getRequiredEnvVar("REACT_APP_TOOLS_BASE_URL");

/* URLs */
export const MINT_BASE_URL = getRequiredEnvVar("REACT_APP_MINT_BASE_URL");
export const USER_BASE_URL = getRequiredEnvVar("REACT_APP_USER_BASE_URL");
export const USER_URL = Object.freeze({
  user: {
    profile: "/@:slug",
    myProfile: "/my-profile",
    accountSettings: {
      default: "/@:slug/settings",
      general: "/@:slug/settings/general",
      notifications: "/@:slug/settings/notifications",
      wallets: "/@:slug/settings/wallets",
    },
    marketplace: {
      default: "/@:slug",
      collected: "/@:slug/collected",
      listings: "/@:slug/listings",
      sentOffers: "/@:slug/sent-offers",
      receivedOffers: "/@:slug/received-offers",
    },
  },
});

const ONCHAIN_URLS_ENABLED =
  getOptionalEnvVar("REACT_APP_ONCHAIN_URLS_ENABLED") === "true";

type MintPageUrlOptions = {
  marketplace?: boolean;
};

const mintBaseUrl = new URL(MINT_BASE_URL);

type CollectionIds = {
  id: string;
  onchainId?: string | null;
};
export const getMintPageUrl = (
  { id, onchainId }: CollectionIds,
  options: MintPageUrlOptions = {}
) => {
  const baseUrl = mintBaseUrl;
  const query = options.marketplace ? "?marketplace=true" : "";

  if (ONCHAIN_URLS_ENABLED && onchainId) {
    return `${baseUrl}/${onchainId}${query}`;
  }
  return `${baseUrl}/${id}${query}`;
};

export const getDetailPageUrl = (collection: CollectionIds, tokenId: string) =>
  `${getMintPageUrl(collection)}/t/${tokenId}`;

export const TOOLS_URL = Object.freeze({
  collections: {
    manage: `${TOOLS_BASE_URL}/collections/:collectionId/manage`,
  },
  base: TOOLS_BASE_URL,
});

export const EXTERNAL_URL = Object.freeze({
  KNOWLEDGE_BASE: "https://support.highlight.xyz/knowledge-base/",
  VERIFICATION_SUPPORT:
    "https://support.highlight.xyz/knowledge-base/highlight-toolkit/other-faqs/verification-badge#verification-criteria",
  VERIFICATION_REQUEST_FORM: "https://tally.so/r/nG9vBQ",
});

export const STORAGE_KEYS = Object.freeze({
  claimNftCard: "highlight.user.claimAvatarNft",
});
